import { useTranslation } from 'next-i18next';
import { type VariantProps, tv } from 'tailwind-variants';

import type { CommonProps } from '../../types';

export interface AlertProps
    extends CommonProps,
        VariantProps<typeof AlertStyles> {
    message: string;
}

export const AlertStyles = tv({
    slots: {
        root: 'bg-brand-500 text-buttonPrimary mb-12 rounded-xl py-9 px-12',
    },
});

export const Alert = ({
    className,
    message,
    testId = 'alert',
    ...props
}: AlertProps): JSX.Element => {
    const { t } = useTranslation('event');
    const { root } = AlertStyles();
    const hasHtmlTag = message.charAt(0) === '<';

    return (
        <article
            className={root({ className })}
            {...props}
            data-testid={testId}
        >
            {!hasHtmlTag ? (
                <>
                    <strong className="xs:text-2xl mb-2 block">
                        {t('tickets.alert.alertHeader')}
                    </strong>
                    <p>{message}</p>
                </>
            ) : (
                <div
                    dangerouslySetInnerHTML={{
                        __html: message,
                    }}
                    className="privateDescription"
                ></div>
            )}
        </article>
    );
};
